module.exports = __webpack_public_path__ + "static/img/3_2_1_2.8aae4c58.jpg";